<script setup lang="ts">

import {computed, PropType, ref} from "vue";
import {CategoriesInterface} from "@interfaces/CategoriesInterface.js";
import {trans} from "laravel-vue-i18n";

let props = defineProps({
    category: {
        type: Object as PropType<CategoriesInterface>,
        required: true,
    },
});

const categories = ref([
    {
        slug: 'voor-gamers',
        titleKey: 'pages.category.about.for_gamers.title',
        subTitleKey: 'pages.category.about.for_gamers.subtitle',
        introTextKey: 'pages.category.about.for_gamers.introText',
        image: '/images/mac.png',
        list: [
            {
                titleKey: 'pages.category.about.for_gamers.item1.title',
                contentKey: 'pages.category.about.for_gamers.item1.text',
            },
            {
                titleKey: 'pages.category.about.for_gamers.item2.title',
                contentKey: 'pages.category.about.for_gamers.item2.text',
            }
        ]
    },
    {
        slug: 'voor-thuis',
        titleKey: 'pages.category.about.for_home.title',
        subTitleKey: 'pages.category.about.for_home.subtitle',
        introTextKey: 'pages.category.about.for_home.introText',
        image: '/images/mac.png',
        list: [
            {
                titleKey: 'pages.category.about.for_home.item1.title',
                contentKey: 'pages.category.about.for_home.item1.text',
            },
            {
                titleKey: 'pages.category.about.for_home.item2.title',
                contentKey: 'pages.category.about.for_home.item2.text',
            }
        ]
    },
    {
        slug: 'voor-op-kantoor',
        titleKey: 'pages.category.about.for_office.title',
        subTitleKey: 'pages.category.about.for_office.subtitle',
        introTextKey: 'pages.category.about.for_office.introText',
        list: [
            {
                titleKey: 'pages.category.about.for_office.item1.title',
                contentKey: 'pages.category.about.for_office.item1.text',
            },
            {
                titleKey: 'pages.category.about.for_office.item2.title',
                contentKey: 'pages.category.about.for_office.item2.text',
            }
        ]
    }
]);

let currentCategory = computed(() =>
    categories.value.find((c) => c.slug === props.category.slug)
);

let title = computed(() =>
    currentCategory.value ? trans(currentCategory.value.titleKey) : ''
);
let subTitle = computed(() =>
    currentCategory.value ? trans(currentCategory.value.subTitleKey) : ''
);
let introText = computed(() =>
    currentCategory.value ? trans(currentCategory.value.introTextKey) : ''
);
let image = computed(() =>
    currentCategory.value?.image ?? ''
);
let list = computed(() => {
    if (!currentCategory.value || !currentCategory.value.list) return [];
    return currentCategory.value.list.map(item => ({
        title: trans(item.titleKey),
        content: trans(item.contentKey)
    }));
});

</script>
<template>
    <section id="category-section-about">
        <div>
            <div class="inner-container">
                <div class="container grid">
                    <header>
                        <p class="sub-title">
                            {{ subTitle }}
                        </p>
                        <h2>
                            {{ title }}
                        </h2>
                        <p class="intro-text">
                            {{ introText }}
                        </p>
                    </header>
                    <ul>
                        <li v-for="item in list" :key="item.title">
                            <h3>
                                {{ item.title }}
                            </h3>
                            <p>
                                {{ item.content }}
                            </p>
                        </li>
                    </ul>
                </div>
            </div>
            <div
                v-if="image"
                class="image-container">
                <div
                    class="image">
                    <img
                        :src="image"
                        alt="Standing Desk met Macbook en Imac"
                    >
                </div>
            </div>
        </div>
    </section>
</template>
<style scoped lang="scss">
@use "@scss/pages/category/sections/about";
</style>
